// Selection intent is separate from the phone-derived patient token.
// The server resolves canonical identity and the selected doctor's sharing consent.
export function appointmentLinkFields(appointment) {
  return {
    p_scribe_patient_id: appointment.scribe_patient_id || null,
    p_link_action: appointment.link_action || (appointment.id ? 'preserve' : 'offline'),
  };
}
